module.exports = __webpack_public_path__ + "static/media/weddingHorse.a0632a65.jpg";